/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiFinalRiskOverrideReason } from './InternalApiFinalRiskOverrideReason';
import {
    InternalApiFinalRiskOverrideReasonFromJSON,
    InternalApiFinalRiskOverrideReasonFromJSONTyped,
    InternalApiFinalRiskOverrideReasonToJSON,
    InternalApiFinalRiskOverrideReasonToJSONTyped,
} from './InternalApiFinalRiskOverrideReason';

/**
 * 
 * @export
 * @interface InternalApiFinalRiskOverrideReasonPage
 */
export interface InternalApiFinalRiskOverrideReasonPage {
    /**
     * 
     * @type {number}
     * @memberof InternalApiFinalRiskOverrideReasonPage
     */
    number: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiFinalRiskOverrideReasonPage
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiFinalRiskOverrideReasonPage
     */
    total: number;
    /**
     * 
     * @type {Array<InternalApiFinalRiskOverrideReason>}
     * @memberof InternalApiFinalRiskOverrideReasonPage
     */
    content: Array<InternalApiFinalRiskOverrideReason>;
}

/**
 * Check if a given object implements the InternalApiFinalRiskOverrideReasonPage interface.
 */
export function instanceOfInternalApiFinalRiskOverrideReasonPage(value: object): value is InternalApiFinalRiskOverrideReasonPage {
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function InternalApiFinalRiskOverrideReasonPageFromJSON(json: any): InternalApiFinalRiskOverrideReasonPage {
    return InternalApiFinalRiskOverrideReasonPageFromJSONTyped(json, false);
}

export function InternalApiFinalRiskOverrideReasonPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiFinalRiskOverrideReasonPage {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'],
        'size': json['size'],
        'total': json['total'],
        'content': ((json['content'] as Array<any>).map(InternalApiFinalRiskOverrideReasonFromJSON)),
    };
}

export function InternalApiFinalRiskOverrideReasonPageToJSON(json: any): InternalApiFinalRiskOverrideReasonPage {
    return InternalApiFinalRiskOverrideReasonPageToJSONTyped(json, false);
}

export function InternalApiFinalRiskOverrideReasonPageToJSONTyped(value?: InternalApiFinalRiskOverrideReasonPage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'size': value['size'],
        'total': value['total'],
        'content': ((value['content'] as Array<any>).map(InternalApiFinalRiskOverrideReasonToJSON)),
    };
}

